export const EVENTS_PAGE_LIMIT = 120;
export const SIDEBAR_PANEL_COLLAPSED_STORAGE_KEY = 'pieve:workspace:sidebar:collapsed:v1';
export const HOME_PROJECT_ID = 'project-home';
export const HOME_PROJECT_LABEL = 'Work';
export const SANDBOX_MODE_WORKSPACE_WRITE = 'workspace-write';
export const SANDBOX_MODE_READ_ONLY = 'read-only';
export const SANDBOX_MODE_DONT_ASK = 'dont-ask';
export const SANDBOX_MODE_FULL_ACCESS = 'full-access';
export const THREAD_DEFAULTS_SANDBOX_MODE_PREF_KEY = 'pieve.thread.defaults.sandboxMode';
export const THREAD_DEFAULTS_PROJECT_ID_PREF_KEY = 'pieve.thread.defaults.projectId';
export const MAX_RECENT_COMPANIES = 5;
export const THREAD_DEBUG_MODE_OFF = 'off';
export const THREAD_DEBUG_MODE_FULL = 'full';
